import React from 'react'
import './footer.css'
import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <footer className='section_padding'>
       <div className="footer-links">
        <span><Link className='link' to="/about">About</Link> |</span>
        <span><Link className='link' to="/flavor">Flavors</Link> |</span>
        <span><Link className='link' to="/benefits">Benefits</Link> |</span>
        <span><Link className='link' to="/shop">Shop</Link> |</span>
        <span><Link className='link' to="/contact">Contact</Link> |</span>
        <span><Link className='link' to="/faq">FAQ</Link></span>
       </div>
       <p>opyright & Legal: © 2025 Fusion Drink. All rights reserved.</p>
    </footer>
  )
}

export default Footer